export default __webpack_public_path__ + "297be0b591a12e330262fe3db94f8a23.webp";